import React from 'react';

import { NavItem } from '../components/NavItem';
import { VIEWS } from '../constants';
import { VIEW_TO_PATH } from '../routes';
import { useApp } from '../store/AppContext';
import ViewAsSelect from './sidebarFooter/ViewAsSelect';

export default function SidebarFooter() {
  const {
    handleLogout,
    isManager,
    navBottomRef,
    navigate,
    previewMode,
    realIsManager,
    sidebarCollapsed,
    setSidebarCollapsed,
    appState,
  } = useApp();
  return (
    <div ref={navBottomRef} className="[border-top:1px_solid_#DCE5E7]">
      {realIsManager && !previewMode && !sidebarCollapsed && (
        <div className="pt-[10px] px-[12px] pb-[2px]">
          <ViewAsSelect />
        </div>
      )}
      {realIsManager && !previewMode && sidebarCollapsed && (
        <div
          onClick={() => setSidebarCollapsed(false)}
          title="Voir en tant que…"
          className="flex items-center justify-center py-[14px] px-[0] cursor-pointer"
        >
          <i className="ti ti-eye text-[20px] text-taupe" aria-hidden="true" />
        </div>
      )}
      {isManager && (
        <NavItem
          collapsed={sidebarCollapsed}
          icon="ti-calendar-off"
          label="Congés"
          active={appState.view === VIEWS.LEAVE}
          to={VIEW_TO_PATH.conges}
          onClick={() => navigate(VIEW_TO_PATH.conges)}
        />
      )}
      <NavItem
        collapsed={sidebarCollapsed}
        icon="ti-user-circle"
        label="Mon profil"
        active={appState.view === VIEWS.PROFILE}
        to={VIEW_TO_PATH.profile}
        onClick={() => navigate(VIEW_TO_PATH.profile)}
      />
      <div
        onClick={handleLogout}
        title={sidebarCollapsed ? 'Déconnexion' : ''}
        className={`flex items-center cursor-pointer text-[15px] text-slate font-medium ${sidebarCollapsed ? 'gap-[0] py-[14px] px-[0] justify-center' : 'gap-[12px] py-[12px] px-[16px] justify-start'}`}
      >
        <i className="ti ti-logout text-[20px] text-taupe" aria-hidden="true" />
        {!sidebarCollapsed && 'Déconnexion'}
      </div>
    </div>
  );
}
